import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { TestRunDetails } from "@/features/runs/routes/TestRunDetails";

export const Route = createLazyFileRoute("/_auth/_app/runs/$id/")({
  component: memo(TestRunDetails),
});
